import { render, staticRenderFns } from "./SpecialSale.vue?vue&type=template&id=635f4751&scoped=true&"
import script from "./SpecialSale.vue?vue&type=script&lang=js&"
export * from "./SpecialSale.vue?vue&type=script&lang=js&"
import style0 from "./SpecialSale.vue?vue&type=style&index=0&id=635f4751&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635f4751",
  null
  
)

export default component.exports